<template>
    <b-card>
        <b-card-body>
            <h4>Registration Information</h4>

            <table class="mt-4">
                <tr>
                    <th class="pr-4">Registrant</th>
                    <td>{{registration.firstName}} {{registration.lastName}}</td>
                </tr>
                <tr>
                    <th class="pr-4">Address</th>
                    <td>{{registration.address1}}<span v-if="registration.address2">, {{registration.address2}}</span>, {{registration.city}}, {{registration.state}} &nbsp;{{registration.zip}}</td>
                </tr>
                <tr>
                    <th class="pr-4">E-Mail</th>
                    <td>{{registration.emailAddress}}</td>
                </tr>
                <tr>
                    <th class="pr-4">Phone</th>
                    <td>{{registration.phoneNumber | tel}}</td>
                </tr>
                <tr>
                    <th class="pr-4">Allow SMS</th>
                    <td>
                        <span v-if="registration.sms === 'true'"><i class="fas fa-check"></i></span>
                        <span v-if="registration.sms === 'false'"><i class="fas fa-ban"></i></span>
                    </td>
                </tr>
                <tr>
                    <th class="pt-4 pr-4">Registered</th>
                    <td class="pt-4">{{registration.fee.title}}</td>
                </tr>
                <tr>
                    <th class="pr-4">Confirmation</th>
                    <td>{{registration.code}}</td>
                </tr>
                <tr>
                    <th class="pr-4">Date</th>
                    <td>{{registration.createdAt | moment('MMM D, YYYY, h:mm:ss a')}}</td>
                </tr>
                <tr>
                    <th class="pt-4 pr-4" valign="top">Paid</th>
                    <td class="pt-4">
                        {{registration.totalPaid | currency}} by <span v-if="registration.paymentType === 'cc'">Credit Card</span><span v-if="registration.paymentType === 'po'">Purchase Order</span><span v-if="registration.paymentType === 'na'">Free Registration</span>
                        <br><b-button variant="outline-success" size="sm" class="mt-2" target="_blank" :href="'#/register/receipt/' + registration.conference.id + '/' + registration.code"><i class="fas fa-file-invoice mr-2"></i>Generate Receipt</b-button>
                    </td>
                </tr>
                <tr v-if="registration.discount && registration.discount.code">
                    <th class="pr-4">Discount</th>
                    <td>{{registration.discount.title}} ({{registration.discount.code}})</td>
                </tr>
            </table>

            <div v-if="registration.district || registration.school" class="mt-5">
                <h4 class="mb-4">School Information</h4>

                <table class="mt-4">
                    <tr>
                        <th class="pr-4">School</th>
                        <td>{{registration.school.SchoolName}}</td>
                    </tr>
                    <tr>
                        <th class="pr-4">Address</th>
                        <td>{{registration.school.AddressLine1 | capitalize}}<span v-if="registration.school.AddressLine2">, {{registration.school.AddressLine2}}</span>, {{registration.school.City}}, {{registration.school.State}} &nbsp;{{registration.school.ZipCode}}</td>
                    </tr>
                    <tr>
                        <th class="pt-4 pr-4">District</th>
                        <td class="pt-4">{{registration.district.name}}</td>
                    </tr>
                    <tr>
                        <th class="pr-4">Address</th>
                        <td>{{registration.district.address | capitalize}}<span v-if="registration.district.address_2">, {{registration.district.address_2 | capitalize}}</span>, {{registration.district.city | capitalize}}, {{registration.district.state}} &nbsp;{{registration.district.zip}}</td>
                    </tr>
                </table>
            </div>

            <div v-if="registration.meta && registration.meta.length" class="mt-5">
                <h4 class="mb-4">Additional Information</h4>

                <div v-for="meta in registration.meta" class="mt-3">
                    <div><strong>{{meta.title}}</strong></div>
                    <div>{{meta.value}}</div>
                </div>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "reg-information",
        props: ['reg', 'id', 'code'],
        data: function () {
            return {
                registration: {
                    conference: {},
                    fee: {}
                },
            }
        },
        methods: {
            ...mapActions(['getRegistrationByCode']),
        },
        mounted: function () {
            // if (!this.reg) {
            this.getRegistrationByCode(this.code).then(reg => {
                this.registration = reg;
            }, err => {
                console.error(err);
            });
            // } else {
            //     this.registration = this.reg;
            // }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';


</style>
